( function () {
	'use strict';

	// Usage: <nav-tabs data-navs="navs" data-active="active"></nav-tabs>
	//
	// Creates:
	//
	function navTabs () {
		function link () {
		}

		var directiveData = {
			'link'         : link,
			'restrict'     : 'E',
			'templateUrl'  : '/templates/components/nav-tabs/nav-tabs.html',
			'controller'   : 'NavTabsCtrl',
			'controllerAs' : 'vm',
			'transclude'   : true,
			'scope'        : {
				'navs'     : '=',
				'active'   : '=',
				'callback' : '&'
			}
		};

		return directiveData;
	}

	angular
		.module( 'app.components' )
		.directive( 'navTabs', navTabs );
} )();
